import { combineReducers } from 'redux'

import { extensionsProfile } from './extensions'

export const extensionsReducer = combineReducers({
  extensionsProfile
})
